import { useRef } from 'react';
import { TheirImpactFragment } from "@graphqlTypes";
import { Container, Quote, VideoSingular, HeadlineAnim, RevealWrapper } from "@components";
import { getHighlightMarkup } from "@/core/utils";

import { useViewSize } from '@/providers/ViewSizeContext';
import { useInView } from 'motion/react';
import { AnimVals } from '@/utils/animUtils';

import styles from "./InducteeImpactHero.module.scss";
import className from "classnames/bind";
const cx = className.bind(styles);

type ImpactHeroProps = TheirImpactFragment['inducteeData']['impactHero'];

export default function InducteeImpactHero(props: ImpactHeroProps) {
  const { headline, type, quote, video } = props;
  const isVideo = type[0] === "video";
  const headlineMarkup = getHighlightMarkup(headline);

  // -------------------- Animation

  const rootEl = useRef<HTMLDivElement>(null);
  const { isDesktop } = useViewSize();
  const REVEAL = AnimVals;
  const triggerPercent = isDesktop ? REVEAL.lg.triggerPercent : REVEAL.sm.triggerPercent;
  const isInView = useInView(rootEl, { amount: triggerPercent, once: REVEAL.once });

  // -------------------- Render

  return (
    <section className={cx('inductee-impact-hero')} ref={rootEl}>
      <RevealWrapper isInView={isInView} isEnabled={false}> {/* Creative direction is to not animate the reveal -Gabe */}
        <Container className={cx("container-top")}>
          <div className={cx("headline-wrap")}>
            <HeadlineAnim
              tag="h3"
              text={headlineMarkup}
              className={cx(["title-uc-xxxxl", "headline"])}
              isRevealEnabled={false}
              isInView={isInView}
            />
          </div>
        </Container>
        <div className={cx("video-container")}>
          {isVideo ? (
            <VideoSingular {...video} detail={true} />
          ) : (
            <Quote {...quote} />
          )}
        </div>
      </RevealWrapper>
    </section>
  );

}
